import { useState } from "react";
import { useParams } from "react-router-dom";

import BreadcrumbsComponent from "../../../base/Breadcrumbs.component";
import EditDealershipTabs from "./EditDealershipTabs.component";

const breadcrumb = {
  title: "Create Dealership",
  links: [{ path: "/", name: "" }],
};
const CreateDealershipComponent = () => {
  const { dealershipId } = useParams();
  const [tab, setTab] = useState({
    dealership: true,
    artifacts: false,
    avatars: false,
  });

  const [selectedAvatar, setSelectedAvatar] = useState({
    avatar_id: "",
    voice_id: "",
  });

  return (
    <>
      <BreadcrumbsComponent {...breadcrumb} />

      <EditDealershipTabs edit={false} />
      {/* <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          padding: "16px",
          backgroundColor: "#fff",
          boxShadow:
            "0px 0px 2px 0px rgba(0, 171, 85, 0.2),0px 12px 24px -4px rgba(0, 171, 85, 0.12)",
          overflow: "hidden",
          height: "80vh",
          margin: "2px 15px 3px 3px",
        }}
      >
        <SideTab tab={tab} setTab={setTab} />
        {tab.avatars ? (
          <AvatarsComponent
            setTab={setTab}
            selectedAvatar={selectedAvatar}
            setSelectedAvatar={setSelectedAvatar}
          />
        ) : tab.artifacts ? (
          <ArtifactsParent
            setTab={setTab}
            selectedAvatar={selectedAvatar}
            setSelectedAvatar={setSelectedAvatar}
          />
        ) : (
          <NewDealershipFormComponent setTab={setTab} />
        )}
      </Box> */}
    </>
  );
};

export default CreateDealershipComponent;
